import React from 'react'
import { graphql } from 'gatsby'
import get from 'lodash/get'

import Layout from '../components/Layout'
import FacebookLinkTemplate from '../components/templates/FacebookLinkTemplate'

const FacebookLink = ({data}) => {
  const frontmatter = get(data, 'markdownRemark.frontmatter', {})
  return (
    <Layout frontmatter={frontmatter}>
      <FacebookLinkTemplate
        header={frontmatter.header}
        subheader={frontmatter.subheader}
        text={frontmatter.text}
        list={frontmatter.list}
        link={frontmatter.link}
        buttonText={frontmatter.buttonText}
      />
    </Layout>
  )
}

export default FacebookLink

export const pageQuery = graphql`
  query FacebookLinkByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        templateKey
        title
        description
        header
        subheader
        text
        list
        buttonText
        link
        favicon
      }
    }
  }
`